import { useContext } from 'react';

import { Image, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { WildCardRouteContext } from 'src/context/WildCardRoute/WildCardRouteContext';

import { ComponentProps, SitecoreContextValue } from 'src/lib/ComponentProps';

import { mapFieldsToContentDetails } from 'src/mappers/models/mapFieldsToContentDetails';

import { ContentDetailItem } from 'src/types/ContentDetailsItem';

import { CourseFields } from 'src/components/courseOverview/CourseFields';
import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import { isClinicalTopic } from '../../../utils/isTemplate';

import ContentOverviewAbstract from './_contentOverviewAbstract/ContentOverviewAbstract';
import ContentOverviewTile from './_contentOverviewTile/ContentOverviewTile';

import { ContentOverviewSummaryFields } from './ContentOverviewSummaryFields';

import styles from './ContentOverviewSummary.module.css';
type ContentOverviewSummaryProps = ComponentProps & {
	fields: ContentOverviewSummaryFields & CourseFields;
};

export default function ContentOverviewSummary(props: ContentOverviewSummaryProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const WildCardRoute = useContext(WildCardRouteContext);

	const contentDetailsItem: ContentDetailItem | null = mapFieldsToContentDetails(
		WildCardRoute?.wildCardItemInfo?.Id ?? sitecoreContext.itemId ?? '',
		props.rendering.fields,
		props.fields
	);

	if (isClinicalTopic(props?.fields?.WildCardContentTemplateId) || !contentDetailsItem) {
		return <></>;
	}

	return (
		<section className={styles.section} data-display-pdf-download>
			<div className={`${styles.container} maxWidth padX padYL`}>
				<div className={styles.imageContainer}>
					<EditorHelp text="Please use image with minimum 400px width and 1:1 aspect ratio." />
					<Image field={props.fields.PageImage ?? props.fields.Image} className={styles.image} />
				</div>

				<ContentOverviewTile {...props} contentDetailItem={contentDetailsItem} />

				<ContentOverviewAbstract {...props} />
			</div>
		</section>
	);
}
